import React from "react";
import {
  AiFillGithub,
  AiFillLinkedin,
  AiFillPhone,
  AiFillMail,
} from "react-icons/ai";
import styled from "./SideBar.module.css";

const links = [
  {
    href: "https://github.com/itzmiftah",
    icon: AiFillGithub,
    label: "GitHub",
  },
  {
    href: "https://www.linkedin.com/in/miftahul-islam-b794a817a/",
    icon: AiFillLinkedin,
    label: "LinkedIn",
  },
  {
    href: "mailto:miftahulislam.dev@gmail.com",
    icon: AiFillMail,
    label: "Email",
  },
  {
    href: "tel:+971545267087",
    icon: AiFillPhone,
    label: "Phone",
  },
];

const SideBar = () => {
  return (
    <div className={styled.fix}>
      {links.map(({ href, icon: Icon, label }) => (
        <a
          key={label}
          className={styled.color3}
          target="_blank"
          rel="noreferrer"
          href={href}
          aria-label={label}
        >
          <Icon className={styled.color} />
        </a>
      ))}
    </div>
  );
};

export default SideBar;
